<template>
  <div v-if="mover"
       :class="$setClasses">
    <div :class="$vClass('mover')">
      <div :class="$vClass('mover__img-wrapper')">
        <div
            :class="$vClass('mover__img-wrapper__img')"
            :style="{'background-image': `url(${mover.customLogo})`}" />
      </div>
      <div :class="$vClass('mover__info')">
        <p :class="$vClass('mover__info__name')">{{ mover.customName }}</p>
        <p :class="$vClass('mover__info__address')">
          {{ $t('comparator.offers.offer.mover.address', {
            city: mover.address?.city,
            postal: postal}) }}</p>
        <p v-if="mover.created_year"
           :class="$vClass('mover__info__date')">
          {{ $t('comparator.offers.offer.mover.created', {date: mover.created_year}) }}</p>
      </div>
    </div>
    <div>
      <nxt-core-link :class="$vClass('link')"
        v-if="displayLink"
        :to="{name: 'mover', params: {id: offerId}}"
        class="u-color-primary u-font-weight-normal">
        <font-awesome-icon
          :icon="['fal', 'circle-chevron-right']"
          class="offers-header__header__icon" />
        {{$t('comparator.offers.offer.mover.more')}}
      </nxt-core-link>
    </div>
    <div :class="$vClass('rating')">
      <offer-rating :count="mover.idem_rating_count"
                    :display-rates="displayRates"
                    :hide-no-rating="hideNoRating"
                    :rates="mover.ranking_details"
                    :rating="mover.idem_rating"/>
    </div>
    <div v-if="displayTags && moverTags?.length"
         :class="$vClass('badges')">
      <offer-rating-icon v-for="(tag, index) in moverTags"
                          :key="`tag-${index}`"
                          :alt="tag.name"
                          :content="tag.description ? $t('comparator.offers.offer.mover.tag', {
                            name: tag.name,
                            description: tag.description,
                          }) : tag.name"
                          :src="tag.s3_path"/>
    </div>
    <div :class="$vClass('description')"
          v-if="displayDescription && mover.customer_description"
          v-html="mover.customer_description">
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useOfferStore } from '@/stores';
import OfferRating from './OfferRating.vue';
import OfferRatingIcon from './OfferRatingIcon.vue';

export default {
  name: 'moverDescription',
  nameClassStyle: 'mover-description',
  components: {
    OfferRatingIcon,
    OfferRating,
  },
  props: {
    hideNoRating: Boolean,
    displayLink: Boolean,
    displayRates: Boolean,
    displayDescription: {
      type: Boolean,
      default: false,
    },
    displayTags: {
      type: Boolean,
      default: true,
    },
    mover: Object,
    offerId: String,
  },
  computed: {
    ...mapState(useOfferStore, ['moversTags', 'moversTagsLoading']),
    postal() {
      return this.mover?.address?.postal?.substring(0, 2);
    },
    moverTags() {
      return this.$helpers.offers.formatMoverTags(this.mover, this.moversTags);
    },
  },
  async created() {
    // Call 'movers' API only, when store move tags are empty and current mover has tags
    // Todo, add the reset of the mover tags to call the "moverapp" API again
    try {
      if (!this.moversTags?.length && !this.moversTagsLoading && this.mover?.mover_tags) {
        await this.getMoversTags();
      }
    } catch (error) {}
  },
  methods: {
    ...mapActions(useOfferStore, ['getMoversTags']),
  },
};
</script>

<style scoped lang="scss">
.mover-description {

  &__description, &__link {
    padding-top: 10px;
  }

  &__link {
    font-size: 16px;
    border: none;
    display: inline-block;
    margin-left: 3px;
  }

  &__mover {
    display: flex;
    gap: var(--nxt-space-default);
    border-radius: 4px;

    &__img-wrapper {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 200px;
      min-height: 100px;
      background-color: var(--nxt-color-white);
      border: 1px solid var(--nxt-color-athens-grayapprox);
      border-radius: var(--nxt-border-radius-base);

      &__img {
        flex: 1;
        height: 70px;
        border-radius: var(--nxt-border-radius-base);
        background-color: var(--nxt-color-white);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }

    &__info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      &__name {
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: -0.5px;
        @include breakpoint(desktop) {
          font-size: 21px;
        }
      }

      &__address {
        font-size: 16px;
        text-transform: uppercase;
        margin: 0 0 5px 0;
        font-weight: 600;
      }

      &__date {
        font-size: 16px;
        margin: 0 0 5px 0;
      }
    }
  }

  &__rating {
    display: inline-block;
    padding-top: var(--nxt-space-small);

    :deep(.offer-rating-icon) {
      padding-top: 8px;
    }

    :deep(.el-popover__reference-wrapper) {
      white-space: nowrap;
    }
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: var(--nxt-space-small);
    padding-top: var(--nxt-space-small);
  }

  @include breakpoint(tablet) {
    .mover-description__rating {
      font-size: 22px;
    }
  }
}
</style>
